import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ValueLabel } from 'gematik-form-library';

@Injectable({
  providedIn: 'root',
})
export class FeedbackFrontEndService {
  constructor(private translateService: TranslateService) {}

  getDepartmentOptions(): ValueLabel[] {
    return [
      { value: 'AUTHENTICATION', label: this.translateService.instant('feedback.AUTHENTICATION') },
      { value: 'MY_SERVICES_GENERAL', label: this.translateService.instant('feedback.MY_SERVICES_GENERAL') },
      {
        value: 'MY_SERVICES_PROFILE_DATA_MANAGEMENT',
        label: this.translateService.instant('feedback.MY_SERVICES_PROFILE_DATA_MANAGEMENT'),
      },
      {
        value: 'MY_SERVICES_ORG_MANAGEMENT',
        label: this.translateService.instant('feedback.MY_SERVICES_ORG_MANAGEMENT'),
      },
      { value: 'MY_SERVICES_REGISTRATION', label: this.translateService.instant('feedback.MY_SERVICES_REGISTRATION') },
      {
        value: 'MY_SERVICES_BOARDING',
        label: this.translateService.instant('feedback.MY_SERVICES_BOARDING'),
      },
      {
        value: 'MY_SERVICES_ACCREDITATION',
        label: this.translateService.instant('feedback.MY_SERVICES_ACCREDITATION'),
      },
      {
        value: 'MY_SERVICES_SLR',
        label: this.translateService.instant('feedback.MY_SERVICES_SLR'),
      },
      {
        value: 'APPLICATION_GENERAL',
        label: this.translateService.instant('feedback.APPLICATION_GENERAL'),
      },
      {
        value: 'APPLICATION_TI_ITSM',
        label: this.translateService.instant('feedback.APPLICATION_TI_ITSM'),
      },
    ];
  }
}
